import { render, staticRenderFns } from "./customtemplate.vue?vue&type=template&id=e6f8cdc6"
import script from "./customtemplate.vue?vue&type=script&lang=js"
export * from "./customtemplate.vue?vue&type=script&lang=js"
import style0 from "./customtemplate.vue?vue&type=style&index=0&id=e6f8cdc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports